"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/Visa.tsx
function Visa(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("g", {
    clipPath: "url(#prefix__clip0_300_21)"
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    fillRule: "evenodd",
    d: "M2.408 14.156a7 7 0 017.427-9.109 1 1 0 00.22-1.988 9 9 0 104.675 15.949c1.557-.052 2.677-.527 3.552-.898.249-.106.477-.203.69-.28.54-.193.999-.278 1.535-.179.556.104 1.276.421 2.287 1.195a.75.75 0 00.912-1.192c-1.114-.851-2.05-1.315-2.924-1.477-.893-.166-1.637-.002-2.317.242-.304.11-.591.23-.877.35-.384.16-.765.32-1.18.45a9.038 9.038 0 001.58-3.989l.273-.114c.158-.066.305-.128.436-.18.422-.168.774-.28 1.13-.315.658-.065 1.516.115 2.967 1.225a.75.75 0 00.912-1.192c-1.614-1.233-2.845-1.642-4.027-1.525-.566.055-1.072.228-1.537.413l-.08.032a9.01 9.01 0 00-.71-3.092c.313-.115.599-.236.861-.346l.019-.008c.527-.222.93-.389 1.343-.47.719-.14 1.608-.045 3.22 1.188a.75.75 0 10.91-1.192c-1.814-1.387-3.133-1.719-4.418-1.468-.579.113-1.117.34-1.608.547l-.03.013c-.332.14-.658.277-1.005.396a8.925 8.925 0 00-.418-.596 1.004 1.004 0 00-.134-.144l.655-.738a1 1 0 00-1.495-1.328l-7.295 8.207-1.75-1.75a1 1 0 00-1.414 1.414l2.5 2.5a1 1 0 001.454-.043l6.003-6.752a7 7 0 11-12.341 6.245z",
    clipRule: "evenodd"
  })), /* @__PURE__ */ React__namespace.createElement("defs", null, /* @__PURE__ */ React__namespace.createElement("clipPath", {
    id: "prefix__clip0_300_21"
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}
var Visa_default = Visa;

exports.Visa_default = Visa_default;
